import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFaq = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#84E2F8"
      d="M37.142 18.517c-.44.765-.783 1.556-1.345 2.135-.528.545-1.287.867-1.997 1.245.055-2.147-.109-4.211-.948-6.234l-.952.382c.229 1.048.537 2.002.623 2.976.09 1.03-.03 2.08-.104 3.08-.06-2.123-.377-4.153-1.256-6.054-.45-.973-1.016-1.89-1.53-2.833 2.08-1.513 5.195-.983 6.613 1.155.33.497.543 1.071.852 1.637.044.833.044 1.639.044 2.511"
    />
    <path
      fill="#84E3F9"
      d="M7.392 30.34c-1.257 1.27-3.495.886-4.208-.825-.042-.547-.042-1.07-.042-1.658.394-.863.912-1.51 1.992-1.625 1.92-.022 3.032 1.091 2.802 2.763-.064.465-.356.898-.544 1.346"
    />
    <path
      fill="#00C5F2"
      d="M7.438 30.355c.141-.462.434-.895.498-1.36.23-1.672-.882-2.785-2.748-2.764-.252-1.04-.43-2.086-.634-3.126-.343-1.736-.043-3.424.368-5.102.636-2.596 1.979-4.798 3.927-6.592 2.178-2.006 4.743-3.221 7.718-3.613 2.784-.367 5.426.038 7.93 1.229 1.032.49 2.002 1.167 2.889 1.894.798.655 1.443 1.496 2.201 2.274.56.961 1.126 1.88 1.576 2.852.88 1.9 1.196 3.93 1.256 6.114-.072.784-.139 1.482-.316 2.15-2.269 8.558-12.547 12.45-19.98 7.573-.523-.344-1.022-.727-1.553-1.107l-.702.861c2.534 2.14 5.38 3.342 8.611 3.479 1.398.059 2.808-.159 4.212-.25-.944.238-1.877.618-2.833.69-3.793.286-7.283-.578-10.244-3.08-.76-.643-1.422-1.402-2.176-2.122m16.227-10.618c.812-3.075-.71-5.797-3.688-6.594-3.048-.816-6.283.69-6.972 3.29.455.216.918.44 1.385.655.463.214.93.42 1.389.628.162-.224.276-.403.411-.565.849-1.017 2.444-1.168 3.43-.33.958.815 1.104 2.264.18 3.131-.506.474-1.218.767-1.882 1.02-.487.186-1.049.173-1.622.255l.393 3.439h2.855c.058-.299.154-.572.158-.846.008-.553.255-.798.795-.958 1.546-.46 2.583-1.497 3.168-3.125m-4.556 6.708c-1.235-.49-2.324-.145-2.829.894-.498 1.024-.14 2.23.816 2.75.982.533 2.214.224 2.793-.701.622-.996.35-2.134-.78-2.943"
    />
    <path
      fill="#85E3F9"
      d="M4.235 8.84c-.875-1.055-.699-2.447-.103-3.209a2.49 2.49 0 0 1 2.975-.766c1.249.532 1.733 1.697 1.371 3.148-.275 1.105-1.771 1.925-2.866 1.584-.475-.148-.894-.475-1.377-.758"
    />
    <path
      fill="#012560"
      d="M22.692 34.87c-1.405.088-2.815.305-4.213.247-3.232-.137-6.077-1.34-8.611-3.479l.702-.862c.531.38 1.03.764 1.554 1.108 7.432 4.878 17.71.985 19.98-7.573.176-.668.243-1.366.361-2.11.028-1.1.149-2.15.058-3.18-.086-.974-.394-1.928-.623-2.976l.952-.382c.839 2.023 1.003 4.086.904 6.257-.246 3.128-1.365 5.809-3.354 8.176-1.918 2.285-4.337 3.713-7.238 4.604-.23.06-.355.116-.479.173 0 0 .008 0 .007-.003"
    />
    <path
      fill="#00C5F2"
      d="M22.74 34.874q.104-.088.374-.167-.103.089-.374.167"
    />
    <path
      fill="#FCFEFF"
      d="M23.646 19.79c-.566 1.575-1.603 2.612-3.149 3.072-.54.16-.787.405-.795.957-.004.275-.1.548-.158.847h-2.855l-.393-3.439c.573-.082 1.135-.07 1.622-.255.665-.253 1.376-.546 1.881-1.02.925-.867.78-2.316-.18-3.131-.985-.839-2.58-.687-3.429.33-.135.162-.249.34-.411.565q-.692-.309-1.39-.628c-.466-.216-.93-.439-1.384-.654.69-2.602 3.924-4.107 6.972-3.292 2.978.798 4.5 3.52 3.669 6.648"
    />
    <path
      fill="#FAFEFF"
      d="M19.155 26.474c1.084.78 1.356 1.918.734 2.914-.578.925-1.811 1.234-2.793.7-.955-.52-1.313-1.726-.816-2.749.505-1.04 1.594-1.384 2.875-.865"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFaq);

export default ForwardRef;
